// DeliveryPage.jsx
import { useContext, useState, useEffect } from "react";
import AuthContext from "../../context/authContext";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./deliverypage.css";

const API_URL = "https://api.nwayami.com/api";

const DeliveryPage = () => {
  const { user } = useContext(AuthContext);
  const [enderecos, setEnderecos] = useState([]);
  const [pontoReferencia, setPontoReferencia] = useState("");
  const [instrucoesEntrega, setInstrucoesEntrega] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) {
      navigate("/loginpage");
      return;
    }

    const fetchEnderecos = async () => {
      const token = localStorage.getItem("authToken");
      if (!token) {
        navigate("/loginpage");
        return;
      }

      try {
        const response = await axios.get(`${API_URL}/enderecos/`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setEnderecos(response.data);
      } catch (error) {
        console.error("Erro ao buscar endereços:", error);
      }
    };

    fetchEnderecos();
  }, [user, navigate]);

  const handleFinalizarEntrega = () => {
    if (enderecos.length === 0) {
      alert("Você precisa cadastrar pelo menos um endereço.");
      return;
    }

    // Aqui você pode salvar os dados localmente ou em contexto, se quiser
    // Por agora vamos apenas seguir para a próxima etapa
    navigate("/pagamento", {
      state: {
        pontoReferencia,
        instrucoesEntrega,
        enderecoSelecionado: enderecos[0] // opcionalmente enviar o primeiro endereço
      }
    });
  };

  return (
    <div className="container mt-4">
      <h2 className="mb-4 text-center">📦 Dados de Entrega</h2>

      {/* Informações do usuário */}
      <div className="card p-3 mb-4 shadow">
        <h4>Informações do Cliente</h4>
        <p><strong>Nome:</strong> {user?.username}</p>
        <p><strong>Email:</strong> {user?.email}</p>
        <p><strong>Telefone:</strong> {user?.telefone}</p>
      </div>

      {/* Endereços de entrega */}
      <div className="card p-3 mb-4 shadow">
        <h4>Ponto de Entrega</h4>
        {enderecos.length > 0 ? (
          <ul className="list-group">
            {enderecos.map((endereco, index) => (
              <li key={index} className="list-group-item">
                {endereco.rua}, {endereco.cidade}, {endereco.provincia} - {endereco.pais}
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-muted">Nenhum endereço cadastrado.</p>
        )}
      </div>

      {/* Campos adicionais */}
      <div className="card p-3 shadow">
        <h4>Outras Informações</h4>
        <div className="mb-3">
          <label className="form-label">Ponto de Referência</label>
          <input
            type="text"
            className="form-control"
            value={pontoReferencia}
            onChange={(e) => setPontoReferencia(e.target.value)}
            placeholder="Ex: Próximo à padaria X"
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Instruções para Entrega</label>
          <textarea
            className="form-control"
            value={instrucoesEntrega}
            onChange={(e) => setInstrucoesEntrega(e.target.value)}
            placeholder="Ex: Entregar na portaria"
            rows={3}
          />
        </div>

        <button className="btn btn-primary mt-2" onClick={handleFinalizarEntrega}>
          Continuar para Pagamento
        </button>
      </div>
    </div>
  );
};

export default DeliveryPage;
